export const TT_SQUARE_AD = `TT_Square_Ad`;
export const TT_PORTRAIT_AD = `TT_Portrait_Ad`;
export const SS_SQUARE_AD = `SS_Square_Ad`;
export const SS_PORTRAIT_AD = `SS_Portrait_Ad`;
export const TT_COMPS_SQUARE_AD = `TT_Comps_Square_Ad`;
export const TT_COMPS_PORTRAIT_AD = `TT_Comps_Portrait_Ad`;
export const TCM_PORTRAIT_AD = `TCM_Portrait_Ad`;
export const TCM_SQUARE_AD = `TCM_Square_Ad`;
export const NX_SQUARE_AD = `NX_Square_Ad`;



// WEBPACK FOOTER //
// ./library/app/data/adverts.js